module.exports = __webpack_public_path__ + "static/apple-icon-114x114-1398dac606e2c0b9d3310763a03ad608.png";